// CredMark.org shares the same Firebase database as NovaCert.in
// All certified businesses, applications, and blogs are in the same project
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyB5ESdQweaKqrw99tfQeLrExUQjZb0fPpM",
  authDomain: "novacert-ind.firebaseapp.com",
  projectId: "novacert-ind",
  storageBucket: "novacert-ind.firebasestorage.app",
  messagingSenderId: "448187001614",
  appId: "1:448187001614:web:22c7ad8fd75cc9a3bc455f",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export default app;

